import { Component } from "react";
import Galaxy from "./galaxy";
import wave from "@/images/wave_2732x300.png";
import Title from "@/components/title";
import AzureRequest from "@/services/request";



class Explore extends Component {
  constructor(props) {
    super(props);
    this.fields = [{ id: 0, name: 'Domaine de formation' }];
    this.workFields = [{ id: 0, name: 'Domaine professionnel' }];
    this.state = {
      showCard: null,
      loadingFilters: true,
      selectedField: { id: 0, name: 'Domaine de formation' },
      selectedWorkField: { id: 0, name: 'Domaine professionnel' },
    };
    this.request = new AzureRequest();
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleWorkFieldChange = this.handleWorkFieldChange.bind(this);
  }

  componentDidMount() {
    this.request.post({
      top: 0,
      facets: [
        "Domaine_du_MESRI,count:200,sort:value",
        "Domaine_Professionnel,count:200,sort:value"
      ]
    }).then((response) => {
      response['@search.facets']['Domaine_Professionnel'].forEach((workField, index) => {
        this.workFields.push({
          id: index + 1,
          name: workField.value
        });
      })
      response['@search.facets']['Domaine_du_MESRI'].forEach((field, index) => {
        this.fields.push({
          id: index + 1,
          name: field.value
        });
      });
      this.setState({ loadingFilters: false })
    })
  }

  async handleFieldChange(value) {
    await this.setState({
      selectedField: value,
      selectedWorkField: this.workFields[0],
      filter: `field_${value.name.replaceAll(' ', '_')}`
    });
  }

  async handleWorkFieldChange(value) {
    await this.setState({
      selectedWorkField: value,
      selectedField: this.fields[0],
      filter: `workField_${value.name.replaceAll(' ', '_')}`
    });
  }

  render() {
    return (
      <section className="mt-20 bg-khaki-light bg-milky-way-left bg-no-repeat bg-left-top ">
        <Title
          title="Galaxie"
          subtitle="J'explore l'univers des formations et des domaines professionnels"
          justify="center"
          variant="2"
        />
        {/* {this.state.loadingFilters || (<>
          <div className=" mt-4 flex justify-center items-center gap-2">
            <div className="w-3/4 grid md:grid-cols-2 gap-2">
              <CourseFilter
                name="field"
                options={this.fields}
                onChange={this.handleFieldChange}
                selected={this.state.selectedField}
              />
              <CourseFilter
                name="workFields"
                options={this.workFields}
                onChange={this.handleWorkFieldChange}
                selected={this.state.selectedWorkField}
              />
            </div>
            <button className="p-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </button>
          </div>
        </>)} */}
        <img src={wave} alt="" className="md:-mt-6 lg:-mt-12" />
        <div className="bg-gray-darkest">
          <Galaxy selected={this.state.filter} />
        </div>
      </section>
    );
  }
}

export default Explore;